// src/components/prescriptions/TemplateForm.jsx
import React from 'react';

export default function TemplateForm({ form, setForm }) {
  return (
    <div className="space-y-3">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <label className="block">
          <span className="text-sm text-gray-700">Nome do template</span>
          <input
            className="mt-1 w-full border rounded-md px-3 py-2"
            value={form.template_name}
            onChange={(e) => setForm({ ...form, template_name: e.target.value })}
            required
          />
        </label>
        <label className="block">
          <span className="text-sm text-gray-700">Tipo</span>
          <select
            className="mt-1 w-full border rounded-md px-3 py-2"
            value={form.template_type}
            onChange={(e) => setForm({ ...form, template_type: e.target.value })}
          >
            <option value="medication">Medicação</option>
            <option value="exam">Solicitação de Exame</option>
            <option value="guidance">Orientações</option>
            <option value="certificate">Atestado</option>
          </select>
        </label>
        <label className="block md:col-span-2">
          <span className="text-sm text-gray-700">Título (opcional)</span>
          <input
            className="mt-1 w-full border rounded-md px-3 py-2"
            value={form.title}
            onChange={(e) => setForm({ ...form, title: e.target.value })}
          />
        </label>
      </div>

      <label className="block">
        <span className="text-sm text-gray-700">Orientações (guidance)</span>
        <textarea
          className="mt-1 w-full border rounded-md px-3 py-2 min-h-[100px]"
          value={form.guidance_text}
          onChange={(e) => setForm({ ...form, guidance_text: e.target.value })}
        />
      </label>

      <label className="block">
        <span className="text-sm text-gray-700">Atestado (certificate)</span>
        <textarea
          className="mt-1 w-full border rounded-md px-3 py-2 min-h-[80px]"
          value={form.certificate_text}
          onChange={(e) => setForm({ ...form, certificate_text: e.target.value })}
        />
      </label>
    </div>
  );
}